import { useAppDispatch } from '@app/utils/redux'

import { withAbortSignal } from '@app/packages/abortContext/actions'
import type { ResourceLoader, ResourceMerger } from '@app/packages/resource/Resource'
import { useResource } from '@app/packages/resource/useResource'

import { useEvent } from '@app/hooks/useEvent'

import type { ThunkAction } from '@app/store/thunk'

/** Version of useResource that provides dispatch context with abortation features */
export function useResourceAction<Data, State>(loader: ThunkAction<ResourceLoader<Data, State>>, merger?: ResourceMerger<Data>) {
  const dispatch = useAppDispatch()
  const l = useEvent<ResourceLoader<Data, State>>((state, abortController) => {
    return dispatch(withAbortSignal(abortController.signal, dispatch => dispatch(loader)(state, abortController)))
  })

  return useResource(l, merger)
}
